import { transportData } from '../components/TransportData';

const SECTIONS = [
  {
    title: 'What we collect',
    items: [
      'Your full name and cellphone number',
      'Your route, pickup point, drop-off location and travel date',
      'Your song request, if you choose to add one'
    ]
  },
  {
    title: 'Why we collect it',
    items: [
      'To reserve your seat and create your booking receipt',
      'To contact you about your booking and payment',
      'To play song requests when we leave'
    ]
  },
  {
    title: 'Who helps us handle it',
    items: [
      'EmailJS sends your booking details to us by email',
      'Google stores your booking details in our private booking sheet',
      'WhatsApp carries any message you choose to send us',
      'Residences receive any enquiry you send them on WhatsApp'
    ]
  },
  {
    title: 'Payments and the chatbot',
    items: [
      'We do not collect card details on this website. Deposits are paid directly into the bank account on your receipt',
      'The chatbot runs in your browser, and we do not store what you type into it'
    ]
  },
  {
    title: 'Your rights',
    items: [
      'We do not sell your personal information',
      'Under the Protection of Personal Information Act (POPIA), you can ask to see, correct or delete your information',
      'You can also complain to the Information Regulator of South Africa'
    ]
  }
];

const Privacy = () => {
  const { displayWhatsapp, email } = transportData.contact;

  return (
    <main className="bg-white px-4 pb-16 pt-28">
      <div className="mx-auto max-w-3xl">
        <h1 className="text-4xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: 4 November 2026</p>
        <p className="mt-6 text-gray-700">
          V2V Student Services respects your privacy. This page explains what we do with the
          information you give us when you use this website.
        </p>

        {SECTIONS.map(({ title, items }) => (
          <section key={title} className="mt-8">
            <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-gray-700">
              {items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        ))}

        <section className="mt-8">
          <h2 className="text-xl font-semibold text-gray-900">Contact us</h2>
          <p className="mt-3 text-gray-700">
            For any privacy request, WhatsApp {displayWhatsapp} or email {email}.
          </p>
        </section>
      </div>
    </main>
  );
};

export default Privacy;
